
import _, { isNil } from 'lodash';
import React from 'react';

import { openDialog } from '../../../base/dialog';
import { translate } from '../../../base/i18n';
import { IconCrown } from '../../../base/icons';
import { PARTICIPANT_ROLE } from '../../../base/participants';
import { connect } from '../../../base/redux';
import { showNotification } from '../../../notifications';
import AbstractGrantModeratorButton, {
    type Props,
    _mapStateToProps
} from '../AbstractGrantModeratorButton';

import VideoMenuButton from './VideoMenuButton';

import { GrantModeratorDialog } from '.';


/**
 * Implements a React {@link Component} which displays a button for granting
 * moderator to a participant.
 */
class GrantModeratorButton extends AbstractGrantModeratorButton {
    /**
     * Instantiates a new {@code GrantModeratorButton}.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);

        this._handleClick = this._handleClick.bind(this);
    }

    /**
   * Handles clicking / pressing the button, and kicks the participant.
   *
   * @private
   * @returns {void}
   */
    _onHandleClick() {
        const { config, dispatch, participant, participantID, jwt, totalModerators, moderators_allowed, t } = this.props;

        if (_.isNil(jwt)) {
            return;
        }
        if (participant.role === PARTICIPANT_ROLE.MODERATOR && totalModerators.length >= moderators_allowed) {
            dispatch(
                    openDialog(GrantModeratorDialog, {
                        participantID: participant.id
                    })
            );

            return;
        } else if (totalModerators.length >= moderators_allowed) {
            dispatch(showNotification({
                descriptionArguments: { number: moderators_allowed },
                descriptionKey: 'notify.maxGrantModeratorDes',
                titleKey: 'notify.maxGrantModerator',
                customActionNameKey: 'notify.upgradeNow',
                customActionHandler: () => window.open(`${config?.URL_PREFIX}updateSubscription`, '_new')
            }));

            return;
        }
        if (isNil(jwt)) {
            dispatch(showNotification({
                descriptionKey: t('prejoin.youAreNotAllowed'),
                titleKey: t('prejoin.youAreNotAllowed')
            }));

            return;
        }

        dispatch(openDialog(GrantModeratorDialog, { participantID }));
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { participantID, t, visible } = this.props;

        if (!visible) {
            return null;
        }

        return (
            <VideoMenuButton
                buttonText = { t('videothumbnail.grantModerator') }
                displayClass = 'grantmoderatorlink'
                icon = { IconCrown }
                id = { `grantmoderatorlink_${participantID}` }
                onClick = { this._onHandleClick } />
        );
    }

    _handleClick: () => void;
}

export default translate(connect(_mapStateToProps)(GrantModeratorButton));
